import { defineStore } from "pinia";
import { reactive, ref } from "vue";

import type { LiveConsultStore } from "@/App/components/liveConsult/types/LiveConsultStore";
import type { StartLiveConsultParameters } from "@/App/components/liveConsult/types/StartLiveConsultParameters";

import { liveConsultService } from "@/App/components/liveConsult/liveConsult.service";
import { LiveConsult } from "@/App/components/liveConsult/liveConsult";

export const useLiveConsultStore: () => LiveConsultStore = defineStore("liveConsult", () => {
  const endLiveConsult = async ({ caseId }: { caseId: string }): Promise<void> => {
    if (startedLiveConsults[caseId]) {
      await startedLiveConsults[caseId].hangUp();

      delete startedLiveConsults[caseId];

      liveConsultOn[caseId] = false;
    }
  };

  const liveConsultDetached = ref(false);

  const liveConsultOn: Record<string, boolean> = reactive({});

  const startLiveConsult = ({ caseId }: StartLiveConsultParameters): void => {
    startedLiveConsults[caseId] = new LiveConsult({ caseId, liveConsultService });

    liveConsultOn[caseId] = true;
  };

  const startedLiveConsults: LiveConsultStore["startedLiveConsults"] = {};

  return {
    endLiveConsult,
    liveConsultDetached,
    liveConsultOn,
    startLiveConsult,
    startedLiveConsults,
  };
});
